import { gql } from "@apollo/client";

export const GET_TOP_COMMON_ISSUES = gql`
  query getTopCommonIssues($filters_config: FiltersConfigInput) {
    top_common_issues(filters_config: $filters_config) {
      last_updated
      common_issues
    }
  }
`;

export interface TopCommonIssuesFiltersConfig {
  filtersjson?: unknown;
  scopesjson?: unknown;
  scopesid?: string;
}

export interface TopCommonIssuesVariables {
  filters_config?: TopCommonIssuesFiltersConfig;
}

export interface TopCommonIssuesResponse {
  top_common_issues?: {
    last_updated?: string | null;
    // `common_issues` is a JSON-encoded string parsed into TopCommonIssueRow[].
    common_issues?: string | null;
  } | null;
}

export interface TopCommonIssueRow {
  name: string;
  source: string;
  category: string;
  count: number;
  rule_id: string;
  datasource_name: string;
  severity: string;
}
